<template>
  <div class='xy-content-module'>
    <div class='xy-content-title xy-flex xy-between xy-center'>
      <div><!--这里是按钮 --></div>
      <div><!--这里是右侧的筛选 --></div>
    </div>
    <div class='xy-content-body'>
      <!-- 指标列 -->
      <div class="index-box" v-for="(i, j) in list" :key="j">
        <div class="sec-index">{{i.ActivityCourseProjectTargetName}} </div>
        <ul class="th-index-list">
          <li class="th-index" v-if="i.Childrens.length === 0">
            <van-checkbox style="border-radius: 2px" icon-size="22" checked-color="#1677FF" shape="square" v-model="i.checked" @click="ischeck(i,false)"></van-checkbox>
            <div class="index-li">
              <p class="index-txt">{{i.ActivityCourseProjeictTargetName}} </p>
              <div @click="clear(i)" v-if="ScoreType === 0">
                <van-rate v-model="i.DefaultValue" :count="i.MaxValue" :void-icon="rateUrl" color="#FADB14" :size="26" @change="ischeck(i, true)" />
              </div>
              <div class="score-slider" v-else>
                <span>{{i.MinValue}}分</span>
                <van-slider @change="ischeck(i, true)" :min="i.MinValue" :max="i.MaxValue" v-model="i.DefaultValue" bar-height="10px" active-color="#4196FF">
                  <template #button>
                    <div class="seekBar">
                      <div class="bubble">{{i.DefaultValue}}分 </div>
                    </div>
                  </template>
                </van-slider>
                <span>{{i.MaxValue}}分</span>
              </div>
            </div>
          </li>
          <li v-else class="th-index" v-for="(item, index) in i.Childrens" :key="index">
            <van-checkbox style="border-radius: 2px" icon-size="22" checked-color="#1677FF" shape="square" v-model="item.checked" @click="ischeck(item)"></van-checkbox>
            <div class="index-li">
              <p class="index-txt">{{item.ActivityCourseProjectTargetName}} </p>
              <div @click="clear(item)" v-if="ScoreType === 0">
                <van-rate @change="ischeck(item, true)" v-model="item.DefaultValue" :count="item.MaxValue" :void-icon="rateUrl" color="#FADB14" :size="26" />
              </div>
              <div class="score-slider" v-else>
                <span>{{item.MinValue}}分</span>
                <van-slider @change="ischeck(item, true)" :min="item.MinValue" :max="item.MaxValue" v-model="item.DefaultValue" bar-height="10px" active-color="#4196FF">
                  <template #button>
                    <div class="seekBar">
                      <div class="bubble">{{item.DefaultValue}}分 </div>
                    </div>
                  </template>
                </van-slider>
                <span>{{item.MaxValue}}分</span>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="sigle-bottom-btn">
      <div class="select-class" @click="checkClass">选择学生</div>
    </div>
  </div>
</template>
<script>
  import { Toast } from 'vant'
  export default {
    name: 'ActivityEvaluationDetails',
    data () {
      return {
        rateUrl: require('./img/voidRate.png'),
        // 指标
        list: [],
        ScoreType: '',
        scoreDatas: [],
        popupData: [],
        isLoad: false,
        minItem:0,
        dItem:0
      }
    },
    created () {
      Toast.setDefaultOptions('loading', { duration: 0 })
      this.ScoreType = Number(this.$route.query.ActivityCourseScoreType)
      this.getListTaget()
    },
    mounted () {},
    methods: {
      loading() {
        Toast.loading({
          message: '加载中...',
          className: 'ipad_toast',
          forbidClick: true
        })
      },
      unloading() {
        Toast.clear()
      },
      fail(a) {
        Toast.fail({
          message: a,
          className: 'ipad_toast',
          forbidClick: true
        })
      },
      checkClass () {
        if (this.scoreDatas.length !== 0) {
          this.$router.push({
              path: "/ipad/ActivityEvaluationStuList",
              query: {
                scoreDatas: JSON.stringify(this.scoreDatas),
                ActivityCourseProjectID: this.$route.query.ActivityCourseProjectID,
                scoreType: this.ScoreType,
                isEdit: this.$route.query.isEdit
              }
          })
        } else {
          this.fail("请先选择指标")
        }
      },
      //获取指标列表
      async getListTaget(){
        this.loading()
        let params = {
          ActivityCourseProjectID: this.$route.query.ActivityCourseProjectID
        }
        let res = await this.xyapi.get(
        `${this.xyMApi}/eva/api/ActivityCourseProjectPad/GetLastTwoProjectTargetByID`,params
        )
        this.unloading()
        if (res.success) {
          this.list = res.data
          for (var i = 0; i < this.list.length; i++) {
            if (this.list[i].Childrens.length !== 0) {
              this.list[i].Childrens.map((item) => {
                this.$set(item, 'checked', false)
                this.$set(item, 'isChange', false)
              })
            } else {
              this.$set(this.list[i], 'checked', false)
              this.$set(this.list[i], 'isChange', false)
            }
          }
        }
      },
      ischeck (item, sel) {
        this.dItem = item.DefaultValue
        this.minItem = item.MinValue
        item.isChange = item.DefaultValue === 1 ? true : false
        //默认值小于设置的最小值时 取消选中
        if (item.DefaultValue < item.MinValue) {
          item.checked = false
          let ins = -1
          for(let i=0,len=this.scoreDatas.length;i<len;i++){
            if(!this.scoreDatas[i].checked){
              ins=i
            }
          }
          if(ins!==-1){ this.scoreDatas.splice(ins,1) }
          this.fail(`指标项评价最小值为${item.MinValue}`)
          return false
        }
        setTimeout(() => {
          item.isChange = item.DefaultValue === 1 ? false : true
          if (sel && !item.checked) {
            item.checked = true
            this.scoreDatas.push(item)
          } else if(!sel) {
            let indexs = -1
            item.checked = item.checked ? false :true
            item.checked = !item.checked ? true :false
            if (item.checked) {
              this.scoreDatas.push(item)
            }else{
              for(let i=0,len=this.scoreDatas.length;i<len;i++){
                if(this.scoreDatas[i].ActivityCourseProjectTargetID ===item.ActivityCourseProjectTargetID){
                  indexs=i
                }
              }
            }
            if(indexs!==-1)
              this.scoreDatas.splice(indexs,1)     
          }
        }, 100)
      },
      // 清除选择
      clear (item) {
        // 原本等于1 或者 改变得分为1后再次点击
        if (item.DefaultValue === 1 && !item.isChange) {
          item.DefaultValue = 0
          this.dItem = item.DefaultValue
          this.minItem = item.MinValue
          if (item.DefaultValue >= item.MinValue) {
            item.checked = true
            item.isChange = false
            this.scoreDatas.push(item)
          } else {
            item.checked = false
            let ins = -1
            for(let i=0,len=this.scoreDatas.length;i<len;i++){
              if(!this.scoreDatas[i].checked){
                ins=i
              }
            }
            if(ins!==-1){ this.scoreDatas.splice(ins,1) }
            this.fail(`指标项评价最小值为${item.MinValue}`)
            return false
          }
        }
      }
    }
  }
</script>
<style lang='less' scoped>
.xy-content-body {
  margin-bottom: 160px;
  /deep/ img {
    vertical-align: baseline !important;
  }
}
.changeAll{
  background: #fff;
  height: 80px;
  width: 100%;
  border-bottom: 20px solid #f5f5f5;
  font-size: 18Px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  div{
    padding:10px;
    flex: 1;
    text-align: center;
    img{
      width:16px;
      height:10px;
      margin-left:10px;
    }
  }
}
.index-box {
  .sec-index {
    font-size: 16Px;
    margin: 10px 0;
    padding-left: 50px;
    color: rgba(0,0,0,0.35);
  }
  .th-index-list {
    padding: 0 10px 0 15px;
    .th-index {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 10px;
      .index-li {
        background: #fff;
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 962px;
        margin-left: 15px;
        height: 116px;
        padding: 20px 30px 20px 19px;
        border-radius: 4px;
        p {
          font-size: 16Px;
          color: rgba(26,26,26,0.85);
          font-weight: 600;
          height: 76px;
          width: 460px;
        }
        .score-slider {
          display: flex;
          align-items: center;
          justify-content: space-between;
          span {
            font-size: 16Px;
            color: rgba(0,0,0,0.45);
            display: inline-block;
          }
          .seekBar {
            width: 36px;
            height: 36px;
            background: url(./img/score.png) no-repeat;
            position: relative;
            background-size: 36px;
            .bubble {
              width: 48px;
              height: 36px;
              background: url(./img/bubble.png) no-repeat;
              color: #1677FF;
              font-size: 16Px;
              text-align: center;
              line-height: 30px;
              position: absolute;
              left: -5px;
              top: -36px;
            }
          }
          /deep/ .van-slider {
            width: 164px;
            margin: 0 18px 0 18px;
          }
        }
      }
    }
    .custom-button {
      width: 24px;
      color: #fff;
      font-size: 10Px;
      line-height: 24px;
      text-align: center;
      background-color: #4196FF;
      border-radius: 100%;
    }
  }
}

.sigle-bottom-btn {
  height: 60px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 21px 0px rgba(186, 186, 186, 0.44);
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;
  z-index: 99999 !important;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px 0 30px;
  .select-class {
    font-size: 16Px;
    color: #1677ff;
  }
  .info-btn {
    width: 74px;
    height: 32px;
    background: #1677ff;
    color: #fff;
    border-radius: 16px;
    text-align: center;
    line-height: 32px;
    font-size: 14Px;
  }
}
</style>
